import PropTypes from 'prop-types';
import { localizeAmountOnly } from '%app/js/common/services/localizeMoney';
import TextField from '%app/js/common/components/material/TextField/component/TextField';

export default class MoneyField extends TextField {
    constructor(props) {
        super(props);

        const { input: { value }, currency } = props;

        this.state = {
            value: localizeAmountOnly(value, currency),
        };
    }

    handleBlur(event) {
        super.handleBlur(event);

        const { target: { value } } = event;
        const { currency } = this.props;

        this.setState({ value: localizeAmountOnly(value, currency) });
    }
}

MoneyField.propTypes = {
    ...TextField.propTypes,
    currency: PropTypes.string.isRequired,
};

MoneyField.defaultProps = {
    ...TextField.defaultProps,
};
